import { Box, Divider, Grid, Typography, useTheme } from "@mui/material";
import UsersIcon from "src/assets/icon/users";

// show customer name, email, address, companyid
export const CustomCustomerListItem = ({
  option,
  index,
  getOptionProps,
  onChange,
  handleCloseMenu,
}: any) => {
  const theme = useTheme();
  return (
    <Grid
      container
      component="li"
      {...getOptionProps({ option, index })}
      key={"option_" + option?.id + "_" + index}
      sx={{
        alignItems: "flex-start",
        padding: "8px 8px",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }}
      onClick={() => {
        onChange(null, option);
        handleCloseMenu();
      }}
    >
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <UsersIcon height={20} width={20} />
          <Box>
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.primary",
              }}
            >
              {option.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {option.email && (
                <>
                  <Typography sx={{ fontSize: "11px", color: "#657482" }}>
                    {option.email}
                  </Typography>
                  <Divider
                    style={{
                      width: "1px",
                      height: "12px",
                    }}
                    light
                    orientation="vertical"
                  />
                </>
              )}
              <Typography
                sx={{
                  fontSize: "11px",
                  color: "text.secondary", //"#657482"]
                }}
              >
                {option.registrationNumber}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
